import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PrecipitationChartComponent } from "./precipitation-chart.component";
import { WaterLevelChartComponent } from "./water-level-chart.component";
import { WindChartComponent } from "./wind-chart.component";
import { TemperatureChartComponent } from "./temperature-chart.component";
import { ThermalSensationChartComponent } from "./thermal-sensation-chart.component";
import { DischargeChartComponent } from "./discharge-chart.component";
import { EmptyDataModule } from "../empty-data/empty-data.module";
import { InputErrorsModule } from "src/app/directives/input-errors/input-errors.module";
import { HumidityChartComponent } from "./humidity-chart.component";

@NgModule({
  declarations: [
    PrecipitationChartComponent,
    WaterLevelChartComponent,
    WindChartComponent,
    TemperatureChartComponent,
    ThermalSensationChartComponent,
    DischargeChartComponent,
    HumidityChartComponent,
  ],
  imports: [CommonModule, IonicModule, TranslateModule, EmptyDataModule, FormsModule, ReactiveFormsModule, InputErrorsModule],
  exports: [
    PrecipitationChartComponent,
    WaterLevelChartComponent,
    WindChartComponent,
    TemperatureChartComponent,
    ThermalSensationChartComponent,
    DischargeChartComponent,
    HumidityChartComponent,
  ],
})
export class ChartModule {}
